export const dealTypeFormat = (value) =>
  ({
    BROADBAND_ONLY: 'Broadband',
    BROADBAND_AND_TV: 'Broadband + TV',
    TV_ONLY: 'TV only',
    PHONE_ONLY: 'Telephone only'
  }[value])

export const speedRangeFormat = (rangeFrom, rangeTo) => {
  const fromMb = rangeFrom / 1000
  const toMb = !rangeTo ? '+' : '-' + rangeTo / 1000
  return `${fromMb}${toMb}`
}

export const monthlyCostFormat = (rangeFrom, rangeTo) => {
  const to = !rangeTo ? '+' : `-£${rangeTo}`
  return `£${rangeFrom}${to}`
}

export const broadbandTypesFormat = (value) =>
  ({
    FIBRE: 'Fibre broadband',
    STANDARD: 'Standard broadband',
    NONE: 'No broadband',
    FAST_MOBILE: '5G broadband'
  }[value])

export const mobileBroadbandTypesFormat = (value) =>
  ({
    FIBRE: 'Fibre broadband',
    STANDARD: 'Mobile broadband',
    NONE: 'No broadband',
    FAST_MOBILE: '5G broadband'
  }[value])

export const inclusiveCallTypesFormat = (value) =>
  ({
    EVENINGS_AND_WEEKENDS: 'Evening & weekend calls',
    WEEKENDS: 'Weekend calls',
    ANYTIME: 'Anytime calls',
    NONE: 'No calls included'
  }[value])

export const specialOffersFormat = (value) =>
  ({
    USWITCH_EXCLUSIVES: 'Uswitch exclusives',
    BLACK_FRIDAY: 'Black Friday',
    CYBER_MONDAY: 'Cyber Monday',
    'Existing customer offer': 'Existing customer offers'
  }[value] || value)
